import { Directive, ElementRef, AfterViewInit, Input } from '@angular/core';

@Directive({
  selector: '[scrollToSelected]'
})
export class ScrollToSelectedDirective implements AfterViewInit {
  @Input() scrollToSelected: string;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    if (this.el.nativeElement.classList.contains(this.scrollToSelected)) {
      this.el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
